<div class="container">

  <div class="row compensate" *ngIf="!loading && !hasOrders">
    <div class="col-12">
      <p class="no-results">
        {{ 'orderhistory.no-orders-found' | translate }}
      </p>
    </div>
  </div>

  <div class="row" *ngIf="hasOrders" infinite-scroll infiniteScrollDistance="1" infiniteScrollThrottle="300" (scrolled)="expand()">
    <div class="col-md-12">

      <h1 class="extrabottommargin">{{ 'orderhistory.orderhistory' | translate }}</h1>

      <!-- Start table -->
      <div class="orderhistorytable" *ngIf="!loading">

        <!-- Start heading -->
        <div class="heading">
          <div class="column column-width-30">{{ 'checkout.address' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.ordernumber' | translate }}</div>
          <!--
          <div class="column column-width-30">{{ 'orderhistory.customer' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.orderedon' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.orderedby' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.totalitems' | translate }}</div>
          -->
          <div class="column column-width-20">{{ 'checkout.fields.reference' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.orderlines' | translate }}</div>
          <div class="column column-width-10">{{ 'orderhistory.totalitems' | translate }}</div>
          <div class="column column-width-10 column-price">{{ 'order.total' | translate }}</div>
          <div class="column column-width-10"></div>
        </div>

        <!-- Start data -->
        <div class="data">
          <!-- Start lines -->
          <div *ngFor="let line of orderHistory" class="data-orderline">
            <div class="column column-width-30 column-address-and-date">
                <strong>{{ line.customerName }} </strong><br/>
                <span class="ordered-on">{{ 'orderhistory.orderedon' | translate }}: {{ orderedOn(line.orderCreatedOnUtc) }} </span>
            </div>
            <div class="column column-width-10">W{{ line.ordernumber }}</div>
            <!--
            <div class="column column-width-30">{{ line.customerName}} ({{ line.customerCode }})</div>
            <div class="column column-width-10">{{ line.userFullName }}</div>
            <div class="column column-width-10">{{ line.totalItems }}</div>
            -->
            <div class="column column-width-20">{{ line.customerReference }}</div>
            <div class="column column-width-10">{{ line.totalOrderLines }}</div>
            <div class="column column-width-10">{{ line.totalItems }}</div>
            <div class="column column-width-10 column-price">{{ line.totalPrice | price: currency }}</div>
            <div class="column column-width-10 text-right"><a [routerLink]="'/orderhistory/' + line.ordernumber" class="btn btn-success btn-icon-right">{{ 'orderhistory.showproducts' | translate }} <i class="fa fa-caret-right"></i></a></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-products-loader
    [loading]="loading || expanding"
    [viewType]="'list-view'"
    [size]="'small'"
    [productsCount]="8">
  </app-products-loader>
</div>
